import {createSelector} from 'reselect';
import {getOptionalPaymentDetailsConsentConfiguration} from './PaymentOptionSelectors';

const getHasOptionalPaymentDetailsConsentCheckbox = paymentMethodType => createSelector(
  [getOptionalPaymentDetailsConsentConfiguration],
  optionalPaymentDetailsConsentConfiguration => !!optionalPaymentDetailsConsentConfiguration && !!Object.entries(optionalPaymentDetailsConsentConfiguration)
    ?.some(consent => consent[0] === paymentMethodType),
);

export default getHasOptionalPaymentDetailsConsentCheckbox;
